import { render, staticRenderFns } from "./EditServiceType.vue?vue&type=template&id=4d8dc0d0&scoped=true&"
import script from "./EditServiceType.vue?vue&type=script&lang=js&"
export * from "./EditServiceType.vue?vue&type=script&lang=js&"
import style0 from "./EditServiceType.vue?vue&type=style&index=0&id=4d8dc0d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8dc0d0",
  null
  
)

export default component.exports